import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import T from '../../Locale';
import { toggleModal } from '../../Actions';
import ModalShare from './ComponentModalShare';
const ComponentActions = ({ hasItems = false, itemsForShare = [], showShareModal }) => {
    const buttonShare = _jsx("button", Object.assign({ type: "button", className: "button purple hollow", onClick: showShareModal }, { children: T.translate('values.shareMarked') }));
    const buttonDownload = _jsx("a", Object.assign({ href: "/values/export", target: "_blank", className: "button purple hollow" }, { children: T.translate('values.download') }));
    return (_jsxs("div", { children: [_jsx(ModalShare, {}), hasItems && itemsForShare.length > 0 && buttonShare, hasItems && buttonDownload] }));
};
ComponentActions.propTypes = {
    hasItems: PropTypes.bool,
    itemsForShare: PropTypes.array,
    showShareModal: PropTypes.func.isRequired
};
const mapStateToProps = (state) => ({
    hasItems: state.values.items && state.values.items.length > 0,
    itemsForShare: state.values.itemsForShare
});
const mapDispatchToProps = (dispatch) => ({ showShareModal: () => { dispatch(toggleModal('share-value')); } });
export default connect(mapStateToProps, mapDispatchToProps)(ComponentActions);
